import { JsonDataItem } from 'types';
import { baseQuery } from '../baseQuery';

export const postCheckTaskLock = async ({ taskId }: JsonDataItem) => {
  const data = await baseQuery('tasks/checksoftlocks', {
    type: 'POST',
    body: {
      tasks: [
        {
          task_id: taskId,
          action: 1, // expand
        },
      ],
      task_ID: taskId,
    },
  });

  return data;
};
